exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "[data-v-2f35d86a] td {\n  cursor: pointer;\n}\n", ""]);

